
export const IconButton = ({ icon, label, onClick, className = '', imgSrc, imgAlt, imgSize = 20 }) => (
  <button
    className={`btn custom-btn d-flex align-items-center justify-content-center ${className}`}
    onClick={onClick}
  >
    {imgSrc ? (
    <img src={imgSrc} alt={imgAlt} width={imgSize} height={imgSize} className="me-2 SvgImg" />

    ) : (
      icon && <span className="me-2 icon-lg">{icon}</span>
    )}
    <span className="custom-btn-label">{label}</span>
  </button>
);
